import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InAppBar from '../core/InAppBar';
import ClassView from './ClassView';
import PropertyView from './PropertyView';

class OntologyEditor extends Component {

  render() {

    const { project, defaultLang, ontologyIRI, expandNode, collapseNode, onBreakLink, onAddNewNode, onDeleteNode, onCollapse,
      onChangeTab, onShowDetail, buildLink, graph, onFound, tabValue, activeClass, selectedTitlePath, onAddExistingNode, hiddenProps,
      expandedPaths, expandedClasses, foundPath, foundRef, foundTime, expandedProperties, viewLang, isFullView, viewWidth,
      onViewWidthChange, onFullViewChange, useSlashIRI, useUuidIRI, iriOptions, excludeDeprecated,
      activeDatatypeProperty, activeObjectProperty, activeAnnotationProperty, onSelectViewLanguage, availableAnnotationProperty } = this.props;

    const appBar = <InAppBar
      tabValue={tabValue}
      onChangeTab={onChangeTab}
      size="small"
      split={1}
      tabItems={[
        { label: "Class" },
        { label: "Annotation" },
        { label: "Datatype" },
        { label: "Object" }]
      } />;

    return (
      <React.Fragment>
        {tabValue === 0 &&
          <ClassView
            id="http://www.w3.org/2002/07/owl#Thing"
            appBar={appBar}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[0]}
            excludeDeprecated={excludeDeprecated}
            activeClass={activeClass}
            expandedPaths={expandedPaths}
            expandedClasses={expandedClasses}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            titlePath={[]}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onBreakLink={onBreakLink("hasSubClass")}
            onAddExistingClass={onAddExistingNode("hasSubClass")}
            onAddNewClass={onAddNewNode(tabValue)}
            onDeleteClass={onDeleteNode}
            onFoundClass={onFound(tabValue)}
            onSelect={onShowDetail(tabValue)}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
        {tabValue === 3 &&
          <PropertyView
            id="http://www.w3.org/2002/07/owl#topObjectProperty"
            searchClass="http://www.w3.org/2002/07/owl#ObjectProperty"
            appBar={appBar}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[3]}
            activeProperty={activeObjectProperty}
            excludeDeprecated={excludeDeprecated}
            expandedPaths={expandedPaths}
            expandedProperties={expandedProperties}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            titlePath={[]}
            childProperty="hasSubProperty"
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onBreakLink={onBreakLink("hasSubProperty")}
            onAddExistingNode={onAddExistingNode("hasSubProperty")}
            onAddNewNode={onAddNewNode(tabValue)}
            onDeleteNode={onDeleteNode}
            onFoundProperty={onFound(tabValue)}
            onSelect={onShowDetail(tabValue)}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
        {tabValue === 2 &&
          <PropertyView
            id="http://www.w3.org/2002/07/owl#topDataProperty"
            searchClass="http://www.w3.org/2002/07/owl#DatatypeProperty"
            appBar={appBar}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[2]}
            activeProperty={activeDatatypeProperty}
            excludeDeprecated={excludeDeprecated}
            expandedPaths={expandedPaths}
            expandedProperties={expandedProperties}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            titlePath={[]}
            childProperty="hasSubProperty"
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onBreakLink={onBreakLink("hasSubProperty")}
            onAddExistingNode={onAddExistingNode("hasSubProperty")}
            onAddNewNode={onAddNewNode(tabValue)}
            onDeleteNode={onDeleteNode}
            onFoundProperty={onFound(tabValue)}
            onSelect={onShowDetail(tabValue)}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
        {tabValue === 1 &&
          <PropertyView
            id="https://graphifi.com/schema/xowl/topAnnotationProperty"
            searchClass="http://www.w3.org/2002/07/owl#AnnotationProperty"
            appBar={appBar}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[1]}
            activeProperty={activeAnnotationProperty}
            excludeDeprecated={excludeDeprecated}
            expandedPaths={expandedPaths}
            expandedProperties={expandedProperties}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            titlePath={[]}
            childProperty="hasSubAnnotationProperty"
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onBreakLink={onBreakLink("hasSubAnnotationProperty")}
            onAddExistingNode={onAddExistingNode("hasSubAnnotationProperty")}
            onAddNewNode={onAddNewNode(tabValue)}
            onDeleteNode={onDeleteNode}
            onFoundProperty={onFound(tabValue)}
            onSelect={onShowDetail(tabValue)}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
      </React.Fragment>
    );
  }

}

OntologyEditor.propTypes = {
  buildLink: PropTypes.func.isRequired,
  graph: PropTypes.string.isRequired,
  activeClass: PropTypes.string,
  activeDatatypeProperty: PropTypes.string,
  activeObjectProperty: PropTypes.string,
  activeAnnotationProperty: PropTypes.string,
  expandedPaths: PropTypes.array,
  expandedClasses: PropTypes.array,
  expandedProperties: PropTypes.array,
  excludeDeprecated: PropTypes.bool,
  foundPath: PropTypes.string,
  foundRef: PropTypes.object,
  foundTime: PropTypes.number,
  viewLang: PropTypes.string,
  onSelectViewLanguage: PropTypes.func.isRequired,
  selectedTitlePath: PropTypes.array,
  ontologyIRI: PropTypes.string.isRequired,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  project: PropTypes.string.isRequired,
  tabValue: PropTypes.number.isRequired,
  expandNode: PropTypes.func.isRequired,
  collapseNode: PropTypes.func.isRequired,
  onAddExistingNode: PropTypes.func.isRequired,
  onAddNewNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired,
  onFound: PropTypes.func.isRequired,
  onBreakLink: PropTypes.func.isRequired,
  onChangeTab: PropTypes.func.isRequired,
  onShowDetail: PropTypes.func.isRequired,
  onCollapse: PropTypes.func,
  isFullView: PropTypes.bool,
  hiddenProps: PropTypes.array,
  onFullViewChange: PropTypes.func.isRequired,
  onViewWidthChange: PropTypes.func.isRequired,
  availableAnnotationProperty: PropTypes.array,
  defaultLang: PropTypes.string.isRequired,
  iriOptions: PropTypes.object
};

export default OntologyEditor;